import React, {Fragment} from 'react'
import Counter from "../../../components/counter";
import {Trans} from "@lingui/react/macro";

export default function ScreenBarPartner({context, campagneData, colors = {}, mini}){

    const partnerMontant = campagneData?.partnerMontant || 1

    const total = campagneData.stats.total.sum.total / partnerMontant


    let bonus = null
    let _objectif = campagneData.objectif
    if(_objectif < total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length > 0){
        bonus = campagneData.bonus.find(b => b > total)
        if(!bonus){
            bonus = campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif = bonus
    }

    const percent = (_objectif>0 ? (total / _objectif) * 100 : 0)
    const displayPercent = (Number(campagneData.objectif)>0 ? (total / campagneData.objectif) * 100 : 0)

    const formater = new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0})

    // Libellé de l'objectif : "OBJECTIF : 100 PARRAINAGES"
    const objectifNb = campagneData.objectif
    const objectifLabel = context.getDonorName(objectifNb)


    return (
        <Fragment>
            <div className={"d-flex justify-content-around align-items-center"} style={{flexDirection: "column", gap: 0}}>

                {/* Grand nombre */}
                <div style={{display: "flex", flexDirection: "column"}}>
                    <span style={{
                        marginTop: "-6vh",
                        textAlign: "center",
                        fontFamily: "YTB-Manier-Bold",
                        fontSize: "40vh",
                        lineHeight: 1,
                        color: "#FFF",
                        textShadow: "rgba(0,0,0,.32) 0px 5px 21px",
                    }}>
                        <Counter number={total} decimals={0} preserveValue/>
                    </span>
                </div>

                {/* Sous-titre objectif
                <div style={{
                    marginTop: "1vh",
                    textAlign: "center",
                    color: "#FFF",
                    fontSize: "4.5vh",
                    fontFamily: "YTB-Cerapro-Bold",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                }}>
                    <Trans>Objectif</Trans> : <span style={{fontFamily: "YTB-Cerapro-Bold"}}>{formater.format(objectifNb)} {objectifLabel}</span>
                </div>

                */}

                {/* Barre de progression */}
                <div style={{
                    backgroundColor: "#FFF",
                    padding: 10,
                    height: "9vh",
                    width: "62vw",
                    borderRadius: 50,
                    overflow: "hidden",
                    marginTop: "7vh",
                }}>
                    <div style={{
                        borderRadius: 50,
                        width: "100%",
                        height: "100%",
                        backgroundColor: colors.barTrack || "#cfe0f5",
                        overflow: "hidden",
                    }}>
                        <div style={{
                            borderRadius: 50,
                            width: percent + "%",
                            height: "100%",
                            background: `linear-gradient(90deg, ${colors.barFrom || "#1a2a9e"} 0%, ${colors.barTo || "#4a6ed8"} 100%)`,
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            paddingRight: "1.8vw",
                        }}>
                            {displayPercent >= 20 && (
                                <span style={{fontSize: "4vh", color: "#FFF", fontFamily: "YTB-Cerapro-Bold"}}>
                                    {Math.floor(displayPercent)}%
                                </span>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </Fragment>
    )
}
